






















import Vue, { PropType } from 'vue';
import { FileUploadBox } from '@/components/ds';
import { Document } from '@/store/modules/admission/state';
import i18n from '@/i18n';

interface SecondGradDocument {
  fileName?: string;
  fileDataUrl?: string;
  isDocumentUploadDone: boolean;
}

export interface SendDocumentFormEvent {
  document: SecondGradDocument;
  documentBack: SecondGradDocument;
}

const FIVE_MB_IN_BYTES = 5 * 1024 ** 2;

export default Vue.extend({
  components: { FileUploadBox },
  props: {
    currentDocument: {
      type: Object as PropType<Document>,
      required: true,
    },
    currentDocumentBack: {
      type: Object as PropType<Document>,
      required: true,
    },
  },
  data() {
    return {
      previousGraduationDiploma: {
        document: {
          fileName: this.currentDocument.name,
          fileDataUrl: this.currentDocument.dataUrl,
          isDocumentUploadDone: Boolean(this.currentDocument.dataUrl),
        },
        documentBack: {
          fileName: this.currentDocumentBack.name,
          fileDataUrl: this.currentDocumentBack.dataUrl,
          isDocumentUploadDone: Boolean(this.currentDocumentBack.dataUrl),
        },
      },
      errorMessages: {
        document: '',
        documentBack: '',
      },
      maxFileSize: FIVE_MB_IN_BYTES,
    };
  },
  methods: {
    documentDeleteHandler(event: Event, index: 'document' | 'documentBack') {
      this.previousGraduationDiploma[index].fileName = '';
      this.previousGraduationDiploma[index].fileDataUrl = '';
      this.previousGraduationDiploma[index].isDocumentUploadDone = false;
      this.errorMessages[index] = '';

      const side = index === 'document' ? 'front' : 'back';
      this.$emit('delete', event, side);
    },
    documentUploadHandler(file: File, index: 'document' | 'documentBack') {
      this.errorMessages[index] = '';
      this.previousGraduationDiploma[index].fileName = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.previousGraduationDiploma[index].fileDataUrl = reader.result as string;
        this.previousGraduationDiploma[index].isDocumentUploadDone = true;
        this.emitInputEvent();
      };
    },
    emitInputEvent() {
      const event: SendDocumentFormEvent = {
        document: this.previousGraduationDiploma.document,
        documentBack: this.previousGraduationDiploma.documentBack,
      };

      this.$emit('input', event);
    },
    errorHandler(error: 'type' | 'size', index: 'document' | 'documentBack') {
      this.errorMessages[index] = i18n.t(`fileUploadError.${error}`);
    },
  },
});
